import PropTypes from 'prop-types';
import FERPA from '../../../../../components/FERPA/FerpaComponent';
import ProgressButton from '../../../../../components/ProgressButton';
import '../styles/companionAppUsageReport.css';
import Skeleton from 'react-loading-skeleton';
import { DateFormatter } from '../../../../../utils/DateFormatter';

const AppUsageReportHeader = ({
  reportTitle,
  filters,
  reportRunDate,
  exportHandler,
  isExporting,
  printHandler,
  isPdfGenerating,
  onBackClick,
  isLoading,
  yearOverYearComparison = false
}) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className='d-flex gap-2'>
          <h1 className='mb-0'>{reportTitle}</h1>
        </div>

        <div id="buttonGroup" className="d-flex gap-3 align-items-center">
          <div className="d-flex align-items-center me-3">
            <FERPA />
          </div>

          <button
            id="export_button"
            disabled={isExporting || isLoading}
            onClick={exportHandler}
            className="btn btn-castleOrange btn-width"
            title="Export report to CSV"
          >
            {isExporting ? 'Exporting...' : 'Export'}
          </button>

          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={printHandler}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleRed"
            expectedDuration={1500}
            disabled={isLoading}
          />

          <button
            id="back_button"
            onClick={onBackClick}
            className="btn btn-castleWhite btn-width"
            title="Return to filter options"
          >
            Back
          </button>
        </div>
      </div>

      {(filters || isLoading) && (
        <div className="student_response_details mb-3">
          <div className="d-flex justify-content-between">
            <div className="student_response_details_left">
              <p>
                District: <strong>{isLoading ? <Skeleton width={120} /> : (filters.districtName || 'All Districts')}</strong>
              </p>
              <p>
                School: <strong>{isLoading ? <Skeleton width={120} /> : (filters.schoolName || 'All Schools')}</strong>
              </p>
              <p>
                Teacher: <strong>{isLoading ? <Skeleton width={120} /> : (filters.teacherName || 'All Teachers')}</strong>
              </p>
              <p>
                Student: <strong>{isLoading ? <Skeleton width={120} /> : (filters.studentName || 'All Students')}</strong>
              </p>
            </div>
            <div className="student_response_details_right">
              <p>&nbsp;</p>
              <p>
                Date Range: <strong>
                  {isLoading
                    ? <Skeleton width={140} />
                    : (filters.isCustomRange && filters.startDateUtc && filters.endDateUtc
                      ? `${DateFormatter.toShortDate2(filters.startDateUtc)} to ${DateFormatter.toShortDate2(filters.endDateUtc)}`
                      : (filters.dateRangeName || 'N/A')
                    )
                  }
                </strong>
              </p>
              <p>
                Year-over-Year Comparison: <strong>{isLoading ? <Skeleton width={40} /> : (yearOverYearComparison ? 'On' : 'Off')}</strong>
              </p>
              <p>
                Report run on: <strong>{isLoading ? <Skeleton width={140} /> : reportRunDate}</strong>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

AppUsageReportHeader.propTypes = {
  reportTitle: PropTypes.string,
  filters: PropTypes.shape({
    districtName: PropTypes.string,
    schoolName: PropTypes.string,
    teacherName: PropTypes.string,
    studentName: PropTypes.string,
    dateRangeName: PropTypes.string,
    startDateUtc: PropTypes.string,
    endDateUtc: PropTypes.string,
    isCustomRange: PropTypes.bool
  }),
  reportRunDate: PropTypes.string,
  exportHandler: PropTypes.func.isRequired,
  isExporting: PropTypes.bool,
  printHandler: PropTypes.func.isRequired,
  isPdfGenerating: PropTypes.bool,
  onBackClick: PropTypes.func,
  isLoading: PropTypes.bool,
  yearOverYearComparison: PropTypes.bool
};

export default AppUsageReportHeader;
